import { BUFFER_MARGIN } from 'automation-ui-flow-core/canvas/graphConstants';
import calculateNodePositions from 'automation-ui-directed-graph/utils/calculateNodePositions';
import calculateDrawFrameBoundForNode from 'automation-ui-directed-graph/utils/calculateDrawFrameBoundForNode';
import getNodeWrapperWidth from 'automation-ui-directed-graph/utils/getNodeWrapperWidth';
const shouldNodeRender = ({
  nodeId,
  bufferMargin = BUFFER_MARGIN,
  nodeHeights,
  nodeHeight,
  zoomLevel,
  boundingClientRectDimensions: {
    width,
    height
  },
  canvasScrollPositions: {
    canvasLeftScroll,
    canvasTopScroll
  },
  directedGraph
}) => {
  var _nodeHeights$get;
  const estimatedPosition = calculateNodePositions(directedGraph, nodeHeights).get(nodeId);
  const nodeWrapperWidth = getNodeWrapperWidth(nodeId, directedGraph);
  const nodeWrapperHeight = (_nodeHeights$get = nodeHeights.get(`node-${nodeId}`)) !== null && _nodeHeights$get !== void 0 ? _nodeHeights$get : nodeHeight;
  const {
    leftEdge,
    rightEdge,
    topEdge,
    bottomEdge
  } = calculateDrawFrameBoundForNode({
    estimatedPosition: estimatedPosition,
    nodeWrapperHeight,
    nodeWrapperWidth,
    bufferMargin
  });
  return !(rightEdge < (canvasLeftScroll - width - bufferMargin) / zoomLevel || leftEdge > (canvasLeftScroll + width + bufferMargin) / zoomLevel || bottomEdge < (canvasTopScroll - height - bufferMargin) / zoomLevel || topEdge > (canvasTopScroll + height + bufferMargin) / zoomLevel);
};
export default shouldNodeRender;